import { render, staticRenderFns } from "./StructuralSubdivisionUserFooter.vue?vue&type=template&id=6d1d2672&scoped=true"
import script from "./StructuralSubdivisionUserFooter.vue?vue&type=script&lang=js"
export * from "./StructuralSubdivisionUserFooter.vue?vue&type=script&lang=js"
import style0 from "./StructuralSubdivisionUserFooter.vue?vue&type=style&index=0&id=6d1d2672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1d2672",
  null
  
)

export default component.exports